import React from 'react';
import { Select, Tooltip, type SelectProps } from 'antd';
import { type OperatorSelectorProps } from 'react-querybuilder';
import {
  OPERATOR_SEPARATE_TOOLTIP_MESSAGE,
  NOT_OPERATOR_DISABLED_TOOLTIP_MESSAGE,
} from '../../../constant';
import { getFieldSchema, allowMultiSelection, getOperators } from '../utils';
import { type QueryBuilderFieldSchema, type QueryBuilderContext } from '../types';

const defaultOperatorsOptions = getOperators().map((it) => ({
  value: it.name,
  label: it.label,
}));

const Operator = (props: OperatorSelectorProps) => {
  const { rule, schema, path, context, level } = props;
  const fieldSchema = getFieldSchema(rule.field, schema.fields as QueryBuilderFieldSchema[]);
  const { onOperatorChange } = context as QueryBuilderContext;

  const options = (fieldSchema?.operatorOptions ?? defaultOperatorsOptions).map((it) => {
    const isMultipleSelection = rule.value?.length > 1;
    const isFistLevel = level === 1;

    const disabled = !isFistLevel && !allowMultiSelection(it.value) && isMultipleSelection;
    let tooltip = '';
    if (isFistLevel && isMultipleSelection && !allowMultiSelection(it.value)) {
      tooltip = OPERATOR_SEPARATE_TOOLTIP_MESSAGE;
    } else if (disabled) {
      tooltip = NOT_OPERATOR_DISABLED_TOOLTIP_MESSAGE;
    }
    const label = disabled ? <div style={{ opacity: 0.5 }}>{it.label}</div> : it.label;
    return {
      ...it,
      label: tooltip ? (
        <Tooltip title={tooltip} styles={{ body: { wordBreak: 'break-word' } }}>
          {label}
        </Tooltip>
      ) : (
        label
      ),
      disabled,
    };
  }) as SelectProps['options'];

  return (
    <Select
      disabled={!fieldSchema}
      style={{ width: 130 }}
      value={rule.operator}
      options={options}
      onChange={(data) => {
        if (fieldSchema) {
          onOperatorChange(data, path, fieldSchema);
        }
      }}
    />
  );
};

export default React.memo(Operator);
